import { render } from "./FacturacionPlanes.vue?vue&type=template&id=50028155&scoped=true"
import script from "./FacturacionPlanes.vue?vue&type=script&lang=js"
export * from "./FacturacionPlanes.vue?vue&type=script&lang=js"

import "./FacturacionPlanes.vue?vue&type=style&index=0&id=50028155&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50028155"]])

export default __exports__